import React from "react";
import { Modal, Spin } from "antd";
import "./ConfirmCancelReservationPopup.scss";
import { useTranslation } from "react-i18next";

interface Props {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  loading?: boolean;
}

export const ConfirmCancelReservationPopup: React.FC<Props> = ({
  open,
  onClose,
  onConfirm,

  loading = false,
}) => {
  const { t } = useTranslation();
  return (
    <Modal
      open={open}
      centered
      footer={null}
      onCancel={onClose}
      destroyOnClose
      className="confirm-cancel-modal"
    >
      <div className="confirm-cancel-modal__content">
        <div>
          <h2 className="confirm-cancel-modal__title">{t("ConfirmCancellation")}</h2>

          <p className="confirm-cancel-modal__desc">{t("ConfirmCancellationDesc")}</p>
        </div>

        <div className="confirm-cancel-modal__actions">
          <button
            className="confirm-cancel-modal__btn outlined"
            onClick={onClose}
            disabled={loading}
          >
            {t("NoKeepIt")}
          </button>
          <button
            className="confirm-cancel-modal__btn filled"
            onClick={onConfirm}
            disabled={loading}
          >
            {loading ? <Spin size="small" /> : t("YesCancelIt")}
          </button>
        </div>

        {loading && (
          <div className="confirm-cancel-modal__overlay">
            <Spin size="large" />
          </div>
        )}
      </div>
    </Modal>
  );
};
